module.exports = __webpack_public_path__ + "images/emoji/godmode.d6d1b9d8ad2dc6af39ce.png";